import axios from 'axios'

export default class Mandatos {
  constructor(tokenBearer, url, id) {
    this.url = `${url}/api/unimed/versoes/${id}`
    this.urlRecibo = `${url}/api/unimed/versoes/recibo/${id}`
    this.urlReciboExportar = `${url}/api/unimed/versoes/recibo/exportar/${id}`
    this.urlVersaoDocumento = `${url}/api/unimed/anexo/versao`
    this.urlAbas = `${url}/api/unimed/versoes/abasCadu`
    this.tokenBearer = tokenBearer
  }

  async getVersoes(args = '') {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.url}?${args}`,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async getRecibo(idUnimed, exportarArquivo) {
    return new Promise(async (resolve, reject) => {
      let options
      if (exportarArquivo) {
        options = {
          method: 'get',
          url: `${this.urlReciboExportar}?versaoUnimedId=${idUnimed}`,
          headers: {
            Authorization: this.tokenBearer
          },
          responseType: 'blob'
        }
      } else {
        options = {
          method: 'get',
          url: `${this.urlRecibo}?versaoUnimedId=${idUnimed}`,
          headers: {
            Authorization: this.tokenBearer
          }
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async getDocumentoByHistorico(idVersao) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.urlVersaoDocumento}/${idVersao}`,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let responseGet = await axios(options)
        resolve(responseGet)
      } catch (err) {
        reject(err)
      }
    })
  }

  async getAbas() {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: this.urlAbas,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let responseGet = await axios(options)
        resolve(responseGet)
      } catch (err) {
        reject(err)
      }
    })
  }
}
